var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-holder"},[_c('NcButton',{attrs:{"type":"tertiary-on-primary","aria-label":_vm.ariaLabel},on:{"click":function($event){return _vm.$emit('click')}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('MenuPeople',{attrs:{"size":20}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }